import React from 'react';
import ToCSV from './ToCSV';
// import outletsData from '../data/outlets.json'

const AdminView = ({ outlet }) => {

    return (
        <div className="">
            <div className="uploaded-items-container pb-3 px-3 d-none d-lg-block">
                <div style={{ borderBottom: '1px solid #46A4F2', backgroundColor: '#F6F6F6' }} className="d-flex justify-content-between align-items-center py-2 sticky-top">
                    <div style={{ fontSize: '12px' }} className="col-md-1 text-brand fw-bold ps-2">Outlet Id</div>
                    <div style={{ fontSize: '12px' }} className="col-md-5 text-brand fw-bold ps-2">Outlet Name</div>
                    <div style={{ fontSize: '12px' }} className="col-md-5 text-brand fw-bold ps-2">Date</div>
                    <div style={{ fontSize: '12px' }} className="col-md-1 text-brand fw-bold ps-2 d-flex float-end">Download</div>
                </div>

                {
                    outlet.length > 0 &&
                    outlet.map(outlet =>
                        <div key={outlet._id} className="d-flex justify-content-between align-items-center">
                            <div style={{ borderRight: '1px solid #46A4F2', fontSize: '12px' }} className="col-md-1 fw-bold p-2">{outlet.code}</div>
                            <div style={{ borderRight: '1px solid #46A4F2', fontSize: '12px' }} className="col-md-5 fw-bold p-2">{outlet.name}</div>
                            <div style={{ borderRight: '1px solid #46A4F2', fontSize: '12px' }} className="col-md-5 fw-bold p-2">{new Date(outlet.date).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}</div>
                            <div className="col-md-1"><ToCSV data={outlet} /></div>
                        </div>
                    )
                }
            </div>

            <div className="uploaded-items-container-sm d-lg-none px-2">
                <div style={{ borderBottom: '1px solid #46A4F2', backgroundColor: '#F6F6F6' }} className="d-flex justify-content-between align-items-center py-2 sticky-top">
                    <div style={{ fontSize: '10px' }} className="col-2 text-brand fw-bold ps-2">Outlet Id</div>
                    <div style={{ fontSize: '10px' }} className="col-4 text-brand fw-bold ps-2 text-center">Outlet Name</div>
                    <div style={{ fontSize: '10px' }} className="col-4 text-brand fw-bold ps-2 text-center">Date</div>
                    <div style={{ fontSize: '10px' }} className="col-2 text-brand fw-bold ps-2 d-flex float-end">Download</div>
                </div>

                {
                    outlet.length > 0 &&
                    outlet.map(outlet =>
                        <div style={{ height: '30px' }} key={outlet._id} className="d-flex justify-content-between align-items-center">
                            <div style={{ borderRight: '1px solid #46A4F2', fontSize: '10px' }} className="col-2 fw-bold py-2 px-1">{outlet.code}</div>
                            <div style={{ borderRight: '1px solid #46A4F2', fontSize: '10px' }} className="col-5 fw-bold py-2 px-1">{outlet.name}</div>
                            <div style={{ borderRight: '1px solid #46A4F2', fontSize: '10px' }} className="col-4 fw-bold py-2 px-1">{new Date(outlet.date).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}</div>
                            <div className="col-1"><ToCSV data={outlet} /></div>
                        </div>
                    )
                }
            </div>
        </div>
    );
};

export default AdminView;